export default __webpack_public_path__ + "static/media/pankaj@4x.769a2c73.png";